import { render, staticRenderFns } from "./QandA.vue?vue&type=template&id=28e32ee8&scoped=true&"
import script from "./QandA.vue?vue&type=script&lang=js&"
export * from "./QandA.vue?vue&type=script&lang=js&"
import style0 from "./QandA.vue?vue&type=style&index=0&id=28e32ee8&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=28e32ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e32ee8",
  null
  
)

export default component.exports